import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { AddMemberToTeamRequest, RemoveMemberFromTeamRequest } from './team-member.types';

import { requestAddMemberToTeam, requestRemoveMemberFromTeam } from './team-member.actions';

export const useTeamMemberApi = () => {
  const dispatch = useDispatch();

  const addMemberToTeam = useCallback(
    (requestData: AddMemberToTeamRequest, onSuccess?: () => void) => {
      dispatch(requestAddMemberToTeam({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const removeMemberFromTeam = useCallback(
    (requestData: RemoveMemberFromTeamRequest, onSuccess?: () => void) => {
      dispatch(requestRemoveMemberFromTeam({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { addMemberToTeam, removeMemberFromTeam };
};
